module.exports = __webpack_public_path__ + "static/img/5772_phase_function_Paper_PointsHejduk_Prediction.639e59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5772_phase_function_Paper_PointsHejduk_Prediction.png
// module id = RIcx
// module chunks = 0